import React, { useEffect, useState, useCallback } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import { FaEyeSlash } from 'react-icons/fa';
import Cookies from 'js-cookie';
import PageLoader from '../components/PageLoader';

// import React, { useEffect, useState, useCallback } from 'react';
// import Navigation from '../components/Navigation';
// import { NavLink } from 'react-router-dom';
// import base_url from '../config/Config';
// import axios from 'axios';
// import Sidebar from '../components/Sidebar';
// import Spinner from 'react-bootstrap/Spinner';
// import { FaEyeSlash } from 'react-icons/fa';
// import Cookies from 'js-cookie';

// const Repayment = () => {
//     const [repayment, setRepayment] = useState([]);
//     const [isDownloading, setIsDownloading] = useState(false);
//     const [searchOption, setSearchOption] = useState('');
//     const [searchInput, setSearchInput] = useState('');
//     const [currentPage, setCurrentPage] = useState(1);
//     const token = Cookies.get('authToken');

//         const repaymentsPerPage = 50;


//     const getAllRepayment = useCallback(() => {
//     axios.get(`${base_url}/api/repayment/all`, {
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${token}`,
//         },
//     })
//         .then((response) => {
//             const sortedrepay = response.data.sort((a, b) => b.id - a.id); // Sort by ID DESC
//             setRepayment(sortedrepay); // Don't reverse again
//         })
//         .catch((error) => {
//             console.error("Error fetching Repayment list:", error);
//         });
// }, [token]);

//     useEffect(() => {
//         if (token) {
//             getAllRepayment();
//         }
//     }, [token, getAllRepayment]);

//    const handleExportRepayment = async () => {
//     setIsDownloading(true);
//     try {
//         const response = await axios.get(`${base_url}/api/repayments/exportRepayment`, {
//             responseType: 'blob',
//             headers: {
//                 "Content-Type": "application/json",
//                 "Authorization": `Bearer ${token}`,
//             },
//         });

//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 'Repayment.xlsx');
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);

//         alert('Repaymnet List successfully');
//     } catch (error) {
//         console.error('Error generating repayment:', error.response?.data || error.message);
//         alert('Export Repaymnet not shown');
//     } finally {
//         setIsDownloading(false);
//     }
// };


//     const handleSearch = (event) => {
//         event.preventDefault();
//         if (searchOption && searchInput) {
//             let url = '';
//             switch (searchOption) {
//                 case 'borrower_name':
//                     url = `${base_url}/api1/account/verifiedSearchByBorrowerName?borrowerName=${searchInput}`;
//                     break;
//                 case 'borrower_id':
//                     url = `${base_url}/api1/account/verifiedCustomerById?id=${searchInput}`;
//                     break;
//                 case 'phone':
//                     url = `${base_url}/api1/account/verifiedSearchByMobileNumber?mobileNumber=${searchInput}`;
//                     break;
//                 default:
//                     break;
//             }
//             axios.get(url).then(
//                 (response) => {
//                     setRepayment(response.data);
//                 },
//                 (error) => {
//                     console.log(error);
//                 }
//             );
//         }
//     };

    
//     const indexOfLastRepayment = currentPage * repaymentsPerPage;
//     const indexOfFirstRepayment = indexOfLastRepayment - repaymentsPerPage;
//     const repayments = repayment.slice(indexOfFirstRepayment, indexOfLastRepayment);
//     const totalPages = Math.ceil(repayment.length / repaymentsPerPage);
//     const maxPageButtons = 10;

//     const getPaginationRange = () => {
//         const mid = Math.floor(maxPageButtons / 2);
//         let start = Math.max(1, currentPage - mid);
//         let end = Math.min(totalPages, start + maxPageButtons - 1);
//         if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
//         return { start, end };
//     };

//     const { start: startPage, end: endPage } = getPaginationRange();

//     return (
//         <>
//             <div className='overviewsaa'>
//                 <h4>Repayment Details</h4>
//             </div>
//             <div className='navigationss mb-5'>
//                 <Navigation />
//             </div>
//             <div className='container-fluid'>
//                 <div className='row'>
//                     <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//                         <div className='lmssidebar'>
//                             <Sidebar />
//                         </div>
//                     </div>
//                     <div className='col-lg-10 col-md-10'>
//                         <div className='dashboardlms mt-5 text-center'>
//                             <div className='row'>
//                                 <div className='col-md-12'>
//                                     <div className='searchtoll'>
//                                         <form onSubmit={handleSearch}>
//                                             <div className='row'>
//                                                 <div className="col-md-3 col-3">
//                                                     <div className=" required">
//                                                         <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required>
//                                                             <option value="">Search By</option>
//                                                             <option value="borrower_name">Borrower Name</option>
//                                                             <option value="borrower_id">Loan Id</option>
//                                                             <option value="phone">Phone</option>
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-3 col-3">
//                                                     <div className=" required">
//                                                         <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className=" required iconsss">
//                                                         <button type="submit" className="btn btn-sm btn-primary">Search</button>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2 mt-2">
//                                                     <div className='resion'>
//                                                         <NavLink to="#" className="exportbutton" onClick={handleExportRepayment}>
//                                                             {isDownloading ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>Download </>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                     </div>
                                                    
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                                 <div className='col-md-12 col-lg-12'>
//                                     <div className='allcustomer table-responsive  table-striped mt-3'>
//                                         { pageLoading ? <PageLoader text="Loading..." /> : repayment.length > 0  ? (
//                                             <table className="styled-table">
//                                                 <thead>
//                                                     <tr>
//                                                         <th>Repayment_Id</th>
//                                                         <th>Loan_Id</th>
//                                                         <th>Customer_Id</th>
//                                                         <th>EMI_Due_Date</th>
//                                                         <th>EMI_Number</th>
//                                                         <th>EMI_Amount</th>
//                                                         <th>Principal</th>
//                                                         <th>Interest</th>
//                                                         <th>Create_Date</th>
//                                                         <th>Update_Date</th>
//                                                          <th>Status</th>
//                                                         <th>Action</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {repayments.map((data, index) => (
//                                                         <tr key={index}>
//                                                             <td>{data.id}</td>
//                                                             <td>{data.loanId}</td>
//                                                             <td>{data.customerId}</td>
//                                                             <td>{data.installmentDate}</td>
//                                                             <td>{data.installmentNumber}</td>
//                                                             <td>{data.emiAmount}</td>
//                                                             <td>{data.principal}</td>
//                                                             <td>{data.interest}</td>
//                                                             <td>{data.createDate ? new Date(data.createDate).toLocaleDateString() : ''}</td>
//                                                             <td>{data.updateDate ? new Date(data.updateDate).toLocaleDateString() : ''}</td>
//                                                            {/* <td>{data.emiStatus === 0 ? 'Pending' : data.emiStatus === 1 ? 'Paid' : 'Unknown'}</td> */}
//                                                            <td style={{ color: data.emiStatus === 1 ? 'green' : data.emiStatus === 0 ? 'black': 'red', fontWeight:'700'}}>{data.emiStatus === 0? 'Pending': data.emiStatus === 1? 'Paid': 'Unknown'}</td>
//                                                             <td className='iconss'>
//                                                                 <NavLink to={`/loanmaster/ViewLoan?customerId=${data.customerId}&loanId=${data.loanId}`}>
//                                                                     <FaEyeSlash />
//                                                                 </NavLink>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         ) : (
//                                             "No Repayment"
//                                         )}
//                                     </div>
                                    
//                                     <div className="pagination-container">
//                                         <div className="pagination-box">
//                                             {startPage > 1 && (
//                                                 <>
//                                                     <button onClick={() => setCurrentPage(1)}>1</button>
//                                                     <span className="dots">...</span>
//                                                 </>
//                                             )}
//                                             {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
//                                                 <button
//                                                     key={startPage + i}
//                                                     className={currentPage === startPage + i ? 'active' : ''}
//                                                     onClick={() => setCurrentPage(startPage + i)}
//                                                 >
//                                                     {startPage + i}
//                                                 </button>
//                                             ))}
//                                             {endPage < totalPages && (
//                                                 <>
//                                                     <span className="dots">...</span>
//                                                     <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
//                                                 </>
//                                             )}
//                                         </div>
//                                     </div>

//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Repayment;




const Repayment = () => {
    const [repayment, setRepayment] = useState([]);
    const [filteredRepayment, setFilteredRepayment] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const token = Cookies.get('authToken');
    const [permissions, setPermissions] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const repaymentsPerPage = 50;

    //    Pemisiion privillages atart

    useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]))
            .finally(() => setPageLoading(false));
    }, []);
        
            // Permission check helper
            const hasPermission = useCallback((tabName, action) => {
                const tab = permissions.find(t => t.tabName === tabName);
                if (!tab) return false;
                switch (action) {
                    case 'view': return !!tab.canView;
                    case 'edit': return !!tab.canEdit;
                    case 'download': return !!tab.canDelete; // using canDelete for download
                    default: return false;
                }
            }, [permissions]);
    //    Pemisiion privillages end

  
    const getAllRepayment = useCallback(() => {
        if (!hasPermission('Repayment', 'view')) return;
        setPageLoading(true);
        axios.get(`${base_url}/api/repayment/all`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
        .then((response) => {
            // Sort by repayment.id DESC
            const sortedRepay = response.data.sort((a, b) => b.repayment.id - a.repayment.id);
            setRepayment(sortedRepay);
            setFilteredRepayment(sortedRepay);
        })
        .catch((error) => {
            console.error("Error fetching Repayment list:", error);
        })
        .finally(() => setPageLoading(false));
    }, [token, hasPermission]);

    useEffect(() => {
        if (token) {
            getAllRepayment();
        }
    }, [token, getAllRepayment]);

    // Search & Date Filter
    const handleSearch = (event) => {
        event.preventDefault();
        let filtered = [...repayment];

        if (searchOption && searchInput) {
            switch (searchOption) {
                case 'borrowerName':
                    filtered = filtered.filter(item => item.customerName?.toLowerCase().includes(searchInput.toLowerCase()));
                    break;
                case 'loanId':
                    filtered = filtered.filter(item => item.repayment.loanId?.toString() === searchInput);
                    break;
                case 'customerId':
                    filtered = filtered.filter(item => item.repayment.customerId?.toString() === searchInput);
                    break;
                case 'phone':
                    filtered = filtered.filter(item => item.phoneNumber?.toString().includes(searchInput));
                    break;
                default:
                    break;
            }
        }

        if (startDate) {
            filtered = filtered.filter(item => new Date(item.repayment.installmentDate) >= new Date(startDate));
        }
        if (endDate) {
            filtered = filtered.filter(item => new Date(item.repayment.installmentDate) <= new Date(endDate));
        }

        setFilteredRepayment(filtered);
        setCurrentPage(1);
    };

    // Export Excel
    const handleExportRepayment = async () => {
          if (!hasPermission('Repayment', 'download')) {
            alert('You do not have permission to download Repayment.');
            return;
        }
        setIsDownloading(true);
        try {
            let apiUrl = `${base_url}/api/repayments/exportRepayment`;
            if (startDate && endDate) {
                apiUrl = `${base_url}/api/repayment/exportRepaymentByDate?startDate=${startDate}&endDate=${endDate}`;
            }

            const response = await axios.get(apiUrl, {
                responseType: 'blob',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Repayment${startDate && endDate ? `_${startDate}_to_${endDate}` : ''}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('Repayment List successfully downloaded');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export Repayment failed');
        } finally {
            setIsDownloading(false);
        }
    };

    const indexOfLastRepayment = currentPage * repaymentsPerPage;
    const indexOfFirstRepayment = indexOfLastRepayment - repaymentsPerPage;
    const repaymentsToShow = filteredRepayment.slice(indexOfFirstRepayment, indexOfLastRepayment);
    const totalPages = Math.ceil(filteredRepayment.length / repaymentsPerPage);
    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const mid = Math.floor(maxPageButtons / 2);
        let start = Math.max(1, currentPage - mid);
        let end = Math.min(totalPages, start + maxPageButtons - 1);
        if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
        return { start, end };
    };

    const { start: startPage, end: endPage } = getPaginationRange();

     
    if (pageLoading) return <PageLoader text="Loading..." />;

    if (!hasPermission('Repayment', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return (
        <>
            <div className='overviewsaa'>
                <h4>Repayment Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-2 col-3">
                                                    <select className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)}>
                                                        <option value="">Search By</option>
                                                        <option value="borrowerName">Borrower Name</option>
                                                        <option value="loanId">Loan Id</option>
                                                        <option value="customerId">Customer Id</option>
                                                        <option value="phone">Phone</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-2 col-3">
                                                    <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
                                                </div>
                                                <div className="col-md-2 col-2">
                                                    <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                                </div>
                                                <div className="col-md-2 col-2">
                                                    <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                                </div>
                                                <div className="col-md-2 col-1">
                                                    <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                </div>
                                                <div className="col-md-2 col-1">
                                                    <NavLink to="#" className="exportbutton ms-2" onClick={handleExportRepayment}
                                                    disabled={isDownloading || !hasPermission('Repayment', 'download')}>
                                                        {isDownloading ? <Spinner animation="border" size="sm" /> : 'Download'}
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className='col-md-12 col-lg-12'>
                                    <div className='allcustomer table-responsive table-striped mt-3'>
                                        {filteredRepayment.length > 0 ? (
                                            <table className="styled-table">
                                                <thead>
                                                    <tr>
                                                        <th>EMI_Id</th>
                                                        <th>Loan_Id</th>
                                                        <th>C_Id</th>
                                                        <th>Customer_Name</th>
                                                        <th>Phone_Number</th>
                                                        <th>EMI_Due_Date</th>
                                                        <th>EMI_No</th>
                                                        <th>EMI_Amount</th>
                                                        <th>Create_Date</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {repaymentsToShow.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.repayment.id}</td>
                                                            <td>{data.repayment.loanId}</td>
                                                            <td>{data.repayment.customerId}</td>
                                                            <td>{data.customerName}</td>
                                                            <td>{data.phoneNumber}</td>
                                                            <td>{data.repayment.installmentDate}</td>
                                                            <td>{data.repayment.installmentNumber}</td>
                                                            <td>{data.repayment.emiAmount}</td>
                                                            <td>{data.repayment.createDate ? new Date(data.repayment.createDate).toLocaleDateString() : ''}</td>
                                                            <td style={{ color: data.repayment.emiStatus === 1 ? 'green' : data.repayment.emiStatus === 0 ? 'black' : 'red', fontWeight: '700' }}>
                                                                {data.repayment.emiStatus === 0 ? 'Pending' : data.repayment.emiStatus === 1 ? 'Paid' : 'Unknown'}
                                                            </td>
                                                            <td className='iconss'>
                                                                 {hasPermission('Repayment', 'view') ? (
                                                                <NavLink to={`/loanmaster/ViewLoan?customerId=${data.repayment.customerId}&loanId=${data.repayment.loanId}`}>
                                                                    <FaEyeSlash />
                                                                </NavLink>
                                                                 ) : (
                                                                 <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
                                                        )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No Repayment"
                                        )}
                                    </div>

                                    <div className="pagination-container">
                                        <div className="pagination-box">
                                            {startPage > 1 && (
                                                <>
                                                    <button onClick={() => setCurrentPage(1)}>1</button>
                                                    <span className="dots">...</span>
                                                </>
                                            )}
                                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                                <button
                                                    key={startPage + i}
                                                    className={currentPage === startPage + i ? 'active' : ''}
                                                    onClick={() => setCurrentPage(startPage + i)}
                                                >
                                                    {startPage + i}
                                                </button>
                                            ))}
                                            {endPage < totalPages && (
                                                <>
                                                    <span className="dots">...</span>
                                                    <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Repayment;

